/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as RadixUiToggleGroup from "@radix-ui/react-toggle-group";
import type { ComponentProps, Dispatch, SetStateAction } from "react";

import type { ScrollAreaProps } from "../ScrollArea/ScrollArea.emotion";
import { ScrollArea } from "../ScrollArea/ScrollArea.emotion";

const containerStyle: Interpolation = {
  display: "flex",
  flexDirection: "row",
  overflowX: "auto",
  scrollbarWidth: "none",
  width: "fit-content",
};
const scrollAreaStyle: Interpolation = {
  width: "100%",
};

export type TabGroupProps = ComponentProps<typeof RadixUiToggleGroup.Root> & {
  scrollAreaProps?: ScrollAreaProps;
  scrollAreaCSS?: Interpolation;
  setParentState?: Dispatch<
    SetStateAction<ComponentProps<typeof RadixUiToggleGroup.Root>["value"]>
  >;
};

export const TabGroup = ({
  children,
  scrollAreaProps,
  scrollAreaCSS = {},
  setParentState,
  ...props
}: TabGroupProps) => (
  <ScrollArea
    maskLeft
    maskRight
    masksSize="s"
    vertical={false}
    css={[scrollAreaStyle, scrollAreaCSS]}
    {...scrollAreaProps}
  >
    <RadixUiToggleGroup.Root
      onValueChange={(value: TabGroupProps["value"]) => {
        if (setParentState) setParentState(value);
      }}
      css={containerStyle}
      {...props}
    >
      {children}
    </RadixUiToggleGroup.Root>
  </ScrollArea>
);
